import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { MenuItem } from '@material-ui/core';
import { useLanguageOnClose } from '../hooks';

var LanguageItem = function LanguageItem(_a) {
  var children = _a.children,
      forwardedRef = _a.forwardedRef,
      _a$label = _a.label,
      label = _a$label === void 0 ? '' : _a$label,
      onClick = _a.onClick,
      rest = __rest(_a, ["children", "forwardedRef", "label", "onClick"]);

  var onMenuClose = useLanguageOnClose();

  var onItemClick = function onItemClick() {
    onMenuClose && onMenuClose();
    onClick && onClick();
  };

  return React.createElement(MenuItem, Object.assign({
    "aria-label": label,
    onClick: onItemClick,
    title: label,
    ref: forwardedRef
  }, rest, {
    button: true
  }), children);
};

LanguageItem.displayName = 'Navbar.LanguageItem';
var LanguageItemExtra = styled(forwardRef(function (props, ref) {
  return React.createElement(LanguageItem, Object.assign({}, props, {
    forwardedRef: ref
  }));
}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export default LanguageItemExtra;